/**
 * =============================================================================
 * WlRevenueByPlanPieChart
 *
 * Wrapper fino que mapeia `WlFinancialPlanRow` para o componente genérico
 * `WlDistributionDonut`. Mantém a API pública original consumida pela aba
 * "Visão geral" (nenhuma quebra visual).
 *
 * @version 2.0.0
 * RELEASE:
 *   2026-07-21 v1.0.0 - Versao inicial (donut + legenda inline).
 *   2026-07-21 v1.1.0 - Legenda customizada com valor em R$ e percentual.
 *   2026-07-22 v2.0.0 - Refatorado como wrapper de WlDistributionDonut para
 *                       reuso na aba Cobrança (donut por meio de pagamento).
 *                       Mesma aparência, mesma paleta.
 * =============================================================================
 */
import { WlDistributionDonut } from './WlDistributionDonut';
import type { WlFinancialPlanRow } from '@/hooks/wl/useWlFinancialKpis';

interface Props {
  data: WlFinancialPlanRow[];
}

/** Grafico de pizza — MRR por plano (reuso do donut genérico). */
export function WlRevenueByPlanPieChart({ data }: Props) {
  const items = (data ?? []).map((r) => ({
    id: r.plan_id,
    name: r.plan_name,
    value: Number(r.mrr || 0),
  }));

  return <WlDistributionDonut data={items} />;
}
